export default "__VITE_ASSET__e1c846c8__"